var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3703",
    width: 36,
    height: 36,
    rx: 18,
    fill: "#5B73C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M26.2752 12.0267C24.7615 10.7467 22.945 10.1067 21.0275 10L20.7248 10.32C22.4404 10.7467 23.9541 11.6 25.367 12.7733C23.6514 11.8133 21.7339 11.1733 19.7156 10.96C19.1101 10.8533 18.6055 10.8533 18 10.8533C17.3945 10.8533 16.8899 10.8533 16.2844 10.96C14.2661 11.1733 12.3486 11.8133 10.633 12.7733C12.0459 11.6 13.5596 10.7467 15.2752 10.32L14.9725 10C13.055 10.1067 11.2385 10.7467 9.72477 12.0267C8.00917 15.44 7.10092 19.28 7 23.2267C8.51376 24.9333 10.633 26 12.8532 26C12.8532 26 13.5596 25.1467 14.0642 24.4C12.7523 24.08 11.5413 23.3333 10.7339 22.16C11.4404 22.5867 12.1468 23.0133 12.8532 23.3333C13.7615 23.76 14.6697 23.9733 15.578 24.1867C16.3853 24.2933 17.1927 24.4 18 24.4C18.8073 24.4 19.6147 24.2933 20.422 24.1867C21.3303 23.9733 22.2385 23.76 23.1468 23.3333C23.8532 23.0133 24.5596 22.5867 25.2661 22.16C24.4587 23.3333 23.2477 24.08 21.9358 24.4C22.4404 25.1467 23.1468 26 23.1468 26C25.367 26 27.4862 24.9333 29 23.2267C28.8991 19.28 27.9908 15.44 26.2752 12.0267ZM14.6697 21.3067C13.6606 21.3067 12.7523 20.3467 12.7523 19.1733C12.7523 18 13.6606 17.04 14.6697 17.04C15.6789 17.04 16.5872 18 16.5872 19.1733C16.5872 20.3467 15.6789 21.3067 14.6697 21.3067ZM21.3303 21.3067C20.3211 21.3067 19.4128 20.3467 19.4128 19.1733C19.4128 18 20.3211 17.04 21.3303 17.04C22.3394 17.04 23.2477 18 23.2477 19.1733C23.2477 20.3467 22.3394 21.3067 21.3303 21.3067Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8129683fe915c09603345c21d3627d25.svg";
export { ForwardRef as ReactComponent };